<sb-calendar-month [dateTimeRanges]="dateTimeRanges" (chosenMonthChanged)="chosenMonthChanged($event)">
</sb-calendar-month>